<div id="service-request-popup-container" class="fixed inset-x-0 top-20 flex justify-center items-center"
     style="z-index: 100;">
  <div id="service-request-overlay" class="overlay" (click)="closePopup()"></div>
  <div id="service-request-content"
       class="flex gap-2 flex-col min-w-[1000px] rounded-xl px-7 pt-4 pb-6 z-10 origin-top bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">
    <button id="close-popup-btn"
            class="self-end text-gray-400 hover:text-gray-500 focus:outline-none focus:text-gray-500"
            aria-label="close" (click)="closePopup()">
      <svg class="w-5 h-5" fill="none" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
           viewBox="0 0 20 20" stroke="currentColor">
        <path d="M6 18L18 6M6 6l12 12"/>
      </svg>
    </button>
    <table id="service-request-items-table" class="min-w-full">
      <thead>
      <tr>
        <th class="pr-3 py-2 text-left">Serial Number</th>
        <th class="px-3 py-2 text-left">Asset Number</th>
        <th class="px-3 py-2 text-left">Model</th>
        <th class="px-3 py-2 text-left">Make</th>
        <th class="px-3 py-2 text-left">Type</th>
        <th class="px-3 py-2 text-left">Location</th>
        <th class="pl-3 py-2"></th>
      </tr>
      </thead>
      <tbody>
        @for (item of getServiceRequestList(); track $index) {
          <tr id="service-request-item-{{$index}}-row">
            <td class="pr-3 py-2 align-middle">{{ item.serial_number }}</td>
            <td class="px-3 py-2 align-middle">{{ item.asset_number }}</td>
            <td class="px-3 py-2 align-middle">{{ item.model }}</td>
            <td class="px-3 py-2 align-middle">{{ item.make }}</td>
            <td class="px-3 py-2 align-middle">{{ item.type }}</td>
            <td class="px-3 py-2 align-middle">{{ item.location }}</td>
            <td class="pl-3 py-2 align-middle">
              <button id="delete-item-{{$index}}-btn" (click)="deleteItemFormServiceRequest(item)"
                      class="flex justify-center items-center">
                <svg class="w-4 h-4 text-black" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none"
                     viewBox="0 0 24 24">
                  <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                        d="M5 7h14m-9 3v8m4-8v8M10 3h4a1 1 0 0 1 1 1v3H9V4a1 1 0 0 1 1-1ZM6 7h12v13a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1V7Z"/>
                </svg>
              </button>
            </td>
          </tr>
        }
      </tbody>
    </table>
    <button id="create-service-request-btn" (click)="closeAndNavigate()" class="submit-btn self-end">
      Create Service Request
    </button>
  </div>
</div>
